export default [
    // {
    //     title: "总览", id: "1", icon: "el-icon-s-home",
    //     children: [
    //         { id: "1-1", title: "日报", url: "/" },
    //         { id: "1-2", title: "月报", url: "/" },
    //     ]
    // },
    {
        title: "数据中心", id: "2", icon: "el-icon-s-marketing",
        children: [
            { id: "2-9", title: "总览", url: "/overview", permission: [2] },
            { id: "2-0", title: "广告点击率", url: "/clickstat", permission: [1, 2, 3] },
            { id: "2-1", title: "投放数据", url: "/gamedata", permission: [1, 2, 3] },
            { id: "2-2", title: "广告数据", url: "/addata", permission: [1, 2, 3] },
            { id: "2-6", title: "广告位数据", url: "/adtypedata", permission: [1, 2, 3] },
            { id: "2-3", title: "广告组数据", url: "/adgroup", permission: [1, 2, 3] },
            { id: "2-5", title: "收益数据", url: "/revenue", permission: [2] },
            { id: "2-7", title: "游戏收益数据", url: "/game_revenue", permission: [2] },
            { id: "2-10", title: "ECPM曲线", url: "/ecpm", permission: [1, 2, 3] },
            { id: "2-11", title: "异常广告位", url: "/abnormal_placement", permission: [1, 2, 3] },
            { id: "2-8", title: "消耗数据", url: "/cost_report", permission: [1, 2, 3] },
            { id: "2-4", title: "广告下游", url: "/downstream", permission: [2] },
        ]
    },
    {
        title: "广告设置", id: "5", icon: "el-icon-s-tools",
        children: [
            { id: "5-1", title: "广告设置", url: "/ad", permission: [1, 2, 3] },
            { id: "5-3", title: "广告设置(新)", url: "/ad_set", permission: [1, 2, 3] },
            { id: "5-2", title: "计划托管", url: "/collocation", permission: [1, 2, 3]  },
            // { id: "5-3", title: "出价保护", url: "/price_guard", enabled: () => { return window.channel == "xm" }  },
        ]
    },
    {
        title: "广告管理", id: "6", icon: "el-icon-s-tools",
        children: [
            { id: "6-1", title: "广告管理", url: "/admanage", permission: [1, 2, 3], enabled: () => { return window.channel == "xm" } },
            { id: "6-2", title: "媒体管理", url: "/admedia", permission: [1, 2, 3], enabled: () => { return window.channel == "xm" } },
            { id: "6-3", title: "垃圾媒体", url: "/rubbish_media", permission: [1, 2, 3], enabled: () => { return window.channel == "xm" } },
            { id: "6-4", title: "投放托管", url: "/publish", permission: [2] },
            { id: "6-5", title: "OPPO户管理", url: "/oppo_adv", permission: [1,2,3], enabled: () => { return window.channel == "oppo" } },
        ]
    },
    {
        title: "应用中心", id: "3", icon: "el-icon-menu",
        children: [
            { id: "3-1", title: "应用管理", url: "/apps", permission: [1, 2, 3] },
            { id: "3-2", title: "热更管理", url: "/patch", permission: [2, 3] },
            { id: "3-3", title: "崩溃日志", url: "/crash", permission: [1,2,3] },
        ]
    },
    // {
    //     title: "系统设置", id: "4", icon: "el-icon-s-tools",
    //     children: [
    //         { id: "4-1", title: "白名单", url: "/white" },
    //     ]
    // },
]